import { render, staticRenderFns } from "./companyrechargedetails-add-or-update.vue?vue&type=template&id=64f3a9bb&"
import script from "./companyrechargedetails-add-or-update.vue?vue&type=script&lang=js&"
export * from "./companyrechargedetails-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports